const actions = {
  ADD_CONTENT_REQUEST: "CONTENT/ADD_CONTENT_REQUEST",
  ADD_CONTENT_SUCCESS: "CONTENT/ADD_CONTENT_SUCCESS",
  ADD_CONTENT_ERROR: "CONTENT/ADD_CONTENT_ERROR",

  GET_CONTENT_REQUEST: "CONTENT/GET_CONTENT_REQUEST",
  GET_CONTENT_SUCCESS: "CONTENT/GET_CONTENT_SUCCESS",
  GET_CONTENT_ERROR: "CONTENT/GET_CONTENT_ERROR",

  UPDATE_CONTENT_REQUEST: "CONTENT/UPDATE_CONTENT_REQUEST",
  UPDATE_CONTENT_SUCCESS: "CONTENT/UPDATE_CONTENT_SUCCESS",
  UPDATE_CONTENT_ERROR: "CONTENT/UPDATE_CONTENT_ERROR",

  DELETE_CONTENT_REQUEST: "CONTENT/DELETE_CONTENT_REQUEST",
  DELETE_CONTENT_SUCCESS: "CONTENT/DELETE_CONTENT_SUCCESS",
  DELETE_CONTENT_ERROR: "CONTENT/DELETE_CONTENT_ERROR",

  RESUME_CONTENT_REQUEST: "CONTENT/RESUME_CONTENT_REQUEST",
  RESUME_CONTENT_SUCCESS: "CONTENT/RESUME_CONTENT_SUCCESS",
  RESUME_CONTENT_ERROR: "CONTENT/RESUME_CONTENT_ERROR",

  createContent: (payload) => ({
    type: actions.ADD_CONTENT_REQUEST,
    payload,
  }),

  getContent: (payload) => ({
    type: actions.GET_CONTENT_REQUEST,
    payload,
  }),

  updateContent: (payload) => ({
    type: actions.UPDATE_CONTENT_REQUEST,
    payload,
  }),

  deleteContent: (payload) => ({
    type: actions.DELETE_CONTENT_REQUEST,
    payload,
  }),

  resumeContent: (payload) => ({
    type: actions.RESUME_CONTENT_REQUEST,
    payload,
  }),
};
export default actions;
